// cookie
// @ts-ignore
import Cookies from 'js-cookie';
// splitter
import { Link, useParams } from "react-router-dom";
// layouts
import { useEffect } from 'react';

const SuccessPaymentUser = () => {
    const { reference } = useParams();
    const { tracking } = useParams();
    useEffect(() => {
        document.getElementById('site-main')?.classList.remove('main-content')
        document.getElementById('site-main')?.classList.add('bg-payment-new')
        document.getElementById('site-main')?.classList.add('bg-payment-new-home')
        document.getElementById('site-main')?.classList.add('bg-white')
    }, [])
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
    const formatted = formatter.format(now);
    return (
        <>
            <article className={'payment overflow-x-hidden'}>
                <div className="row justify-content-center h-100">
                    <header className={'container text-center'}>
                        <div className="top-bar" style={{ paddingBottom: '15px' }}>
                            <div className="d-flex justify-content-center">
                                <img alt="logo" src={require('./../../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                            </div>
                            <p className="text-white text-center mb-5 fw-bold">
                                سامانه ملی امن, سریع و آسان تراکنش ایران
                            </p>
                        </div>
                    </header>
                    <div className="col-md-6 col-lg-4">
                        <div id={'text-field'}>
                            <section className={'bg-white text-center py-1 my-2 mt-1'}>
                                <p className={'price h5 fw-bold mt-2 dark-green card-text'}>
                                    <span className={'price-amount ms-1'}>
                                        {Cookies.get('payment_amount')}
                                    </span>
                                    تومان
                                </p>
                                <span className="badge my-3 bg-success-site py-2 fw-bold" style={{ fontSize: '18px' }}>
                                    <span className='mx-2'>
                                        {Cookies.get('name') ? Cookies.get('name') : localStorage.getItem('name')}
                                    </span>
                                    عزیز ثبت نام شما با موفقیت انجام شد
                                </span>
                            </section>
                            <ul className="list-group font-small list-group-flush mt-4 px-0">
                                <li className="list-group-item border px-0">
                                    <div className="d-flex justify-content-between">
                                        <span className="text-muted">
                                            کد پذیرندگی
                                        </span>
                                        <span className="fw-bold">
                                            {Cookies.get('nationalCode')}
                                        </span>
                                    </div>
                                    <hr />
                                </li>
                                <li className="list-group-item border px-0">
                                    <div className="d-flex justify-content-between">
                                        <span className="text-muted">
                                            شماره تماس
                                        </span>
                                        <span className="fw-bold">
                                            {Cookies.get('mobileNumber')}
                                        </span>
                                    </div>
                                    <hr />
                                </li>
                                <li className="list-group-item border px-0">
                                    <div className="d-flex justify-content-between">
                                        <span className="text-muted">
                                            زمان
                                        </span>
                                        <span className="fw-bold">
                                            {formatted}
                                        </span>
                                    </div>
                                    <hr />
                                </li>
                                <li className="list-group-item border px-0">
                                    <div className="d-flex justify-content-between">
                                        <span className="text-muted">
                                            شماره پیگیری
                                        </span>
                                        <span className="fw-bold">
                                            {reference}
                                        </span>
                                    </div>
                                    <hr />
                                </li>
                                <li className="list-group-item px-0">
                                    <div className="d-flex justify-content-between">
                                        <span className="text-muted">
                                            شماره مرجع
                                        </span>
                                        <span className="fw-bold">
                                            {tracking}
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {/* footer */}
                        <section className={'action my-1 mt-4'}>
                            <div className={'d-flex justify-content-center'}>
                                <Link to={'/'}
                                    className={'btn btn-site rounded rounded-pill fw-bold px-4 position-relative'}>
                                    <p className={'card-text mb-1 font-medium fw-bold'}>
                                        بازگشت به سایت
                                    </p>
                                    <p className={'font-small mt-0 mb-0'}>
                                        بدون نیاز به نصب اپلیکیشن
                                    </p>
                                </Link>
                            </div>
                        </section>
                    </div>
                </div>
            </article>
        </>
    )
}

export default SuccessPaymentUser;